module.exports = __webpack_public_path__ + "static/oval3.30dcc3e3.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/oval3.png
// module id = 254
// module chunks = 0